<template>
  <div class="animatedGlow">
    <v-card width="256" class="fill-height d-flex flex-column align-content-space-between justify-space-between quiz-card">
      <v-card-title>
        <div class="d-flex justify-space-between fill-width align-center">
          <LTimerPill icon-timer-inactive="mdi-replay"
                      :end-date="DateUtils.getStartOfDate(moment(props.lastPositiveAttempt.allowReattemptAt), 'day',)"
                      :tooltip-title="`Kolejna możliwość zdania testu: ${DateUtils.getFormatedDate(props.lastPositiveAttempt.allowReattemptAt,)}`"
                      :tooltip-text="`Możliwość potwierdzenia będzie dostępna przez ${DateUtils.diff(props.lastPositiveAttempt.hrLockAt, props.lastPositiveAttempt.allowReattemptAt, 'days',)} dni. W przypadku braku potwierdzania po tym czasie system zostanie zablokowany.`"
                      icon-timer-active="mdi-replay"></LTimerPill>
          <v-btn icon @click="emits('closeModal')"> <v-icon>close</v-icon></v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-spacer></v-spacer>
        <v-img :src="require('@/assets/icons/quizes/statements.svg')" width="68px" height="68px"></v-img>
        <div class="mt-5">
          <p class="headline-5 mb-1">Gotowe!</p>
          <p class="body-2 mb-0">
            {{ quizInfoConfig[props.quizCategory]?.successDescription}}
          </p>
        </div>
      </v-card-text>
      <v-card-actions class="fill-width">
        <v-btn
          @click="emits('closeModal')"
          color="primary"
          min-width="100%"
          depressed
        >
        Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
  </template>
<script setup lang="ts">
import DateUtils from '@/services/utils/DateUtils';
import moment from 'moment/moment';
import {QuizCategory} from '@/models/Quiz';
import LTimerPill from '@/components/commons/LTimerPill.vue';
import {CreatedPartnerModel} from '@/models/Partner';
import {QuizTestAttempt} from '@/modules/bhp/models/QuizTest';
const emits = defineEmits<{(e: 'closeModal', partner?: CreatedPartnerModel): void }>();
const props = defineProps<{
  lastPositiveAttempt: QuizTestAttempt,
  quizCategory: QuizCategory
}>()

type QuizInfoConfigSuccess = {
  successDescription: string;
}
const quizInfoConfig: Partial<Record<QuizCategory,QuizInfoConfigSuccess>> = {
  [QuizCategory.STMT]: {
    successDescription: `Wymóg potwierdzenia oświadczenia akredytacyjnego odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
  [QuizCategory.ETHIC]: {
    successDescription: `Wymóg szkolenia odnowi się za ${moment(props.lastPositiveAttempt.allowReattemptAt).diff(moment(), 'days')} dni.`,
  },
}

  
</script>
<style lang="scss" scoped>
  .quiz-card {
    background-color: var(--v-primaryBg-base) !important;
    border-color: fpShadow($border-opacity) !important;
  }
  .animatedGlow {
    position: relative;
    z-index: 210;
  }
  .animatedGlow::after {
    position: absolute;
    content: "";
    top: 15px;
    left: 0;
    right: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    -webkit-filter: blur(50px);
    filter: blur(50px);
    background: -webkit-gradient(linear, right top, left top, from(#22C7FA), color-stop(#23CD30), to(#22C7FA));
    background: linear-gradient(to left, #23CD30, #22C7FA, #23CD30);
    background-size: 200% 200%;
    -webkit-animation: animateGlow 3s linear infinite;
    animation: animateGlow 3s linear infinite;
  }

  @-webkit-keyframes animateGlow {
    0% {
      background-position: 0% 50%; }
    100% {
      background-position: 200% 50%; } }

  @keyframes animateGlow {
    0% {
      background-position: 0% 50%; }
    100% {
      background-position: 200% 50%; } }

</style>
